'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetch = {
  sections: function sections(env) {
    return _jquery2.default.get(_constants.PATHS[env] + 'sections.json');
  },
  user: function user() {
    return new _bluebird2.default(function (resolve) {
      _jquery2.default.post('/users/cookie', function (data) {
        try {
          var user = JSON.parse(data);
          resolve(user.decrypted_cookie);
        } catch (err) {
          resolve({});
        }
      }).fail(function () {
        resolve({});
      });
    });
  },


  /* Use the p-code to update the current account context if not all variables are filled in. */
  context: function context(pCode) {
    return new _bluebird2.default(function (resolve, reject) {
      _store2.default.getAccounts().then(function (accounts) {
        var fullContext = accounts.find(function (account) {
          return account.pCode === pCode;
        });
        if (fullContext) {
          resolve(fullContext);
        } else {
          reject(new Error('No account with this p-code found.'));
        }
      });
    });
  },


  /* Fetch all the account this user has access to from the accounts service. */
  accounts: function accounts() {
    return _jquery2.default.get('/accountservice/api/v1/users/accounts').then(function (data) {
      _store2.default.setAccounts(data.accounts);
      return _bluebird2.default.resolve(data.accounts);
    }).catch(function () {
      _store2.default.setAccounts([]);
      return _bluebird2.default.resolve([]);
    });
  },


  /* Check to see what product should be shown. If context is set, it will use it. */
  product: function product() {
    var currentContext = _store2.default.getContext();
    if (currentContext) {
      return currentContext.isMarketer ? 'advertise' : 'measure';
    }
    return 'measure';
  }
};

exports.default = fetch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/fetch.js
// module id = 98
// module chunks = 0